<template>
  <div v-if="audioSrc" class="audio-player">
    <button class="cd-play" @click="togglePlay" aria-label="Play/Pause">
      <span v-if="!isPlaying">▶</span>
      <span v-else>❚❚</span>
    </button>

    <div class="cd-times">
      <span class="cd-time">{{ formatTime(currentTime) }}</span>

      <input
        class="cd-progress"
        type="range"
        min="0"
        :max="duration || 0"
        step="0.1"
        :value="currentTime"
        @input="onSeek"
      />

      <span class="cd-time">{{ formatTime(duration) }}</span>
    </div>

    <audio
      ref="audioEl"
      :src="audioSrc"
      preload="metadata"
      @loadedmetadata="onLoaded"
      @timeupdate="onTimeUpdate"
      @ended="onEnded"
    />
  </div>
</template>

<script>
export default {
  name: "AudioPlayer",
  props: {
    audioSrc: { type: Object, required: true },
  },
  data() {
    return {
      isPlaying: false,
      currentTime: 0,
      duration: 0,
    };
  },
  watch: {
    "audioSrc": function () {
      this.stop();
    },
  },
  methods: {
    stop() {
      const el = this.$refs.audioEl;
      if (!el) return;
      el.pause();
      el.currentTime = 0;
      this.isPlaying = false;
      this.currentTime = 0;
      this.duration = 0;
    },

    togglePlay() {
      const el = this.$refs.audioEl;
      if (!el) return;

      if (el.paused) {
        el.play()
          .then(() => (this.isPlaying = true))
          .catch((err) => {
            this.isPlaying = false;
            console.error("Audio play failed:", err);
          });
      } else {
        el.pause();
        this.isPlaying = false;
      }
    },

    onLoaded(e) {
      this.duration = e.target.duration || 0;
    },

    onTimeUpdate(e) {
      this.currentTime = e.target.currentTime || 0;
      this.duration = e.target.duration || this.duration;

      const pct = this.duration ? (this.currentTime / this.duration) * 100 : 0;
      const slider = this.$el.querySelector(".cd-progress");
      if (slider) slider.style.setProperty("--pct", `${pct}%`);
    },

    onSeek(ev) {
      const el = this.$refs.audioEl;
      if (!el) return;
      const val = Number(ev.target.value);
      el.currentTime = val;
      this.currentTime = val;
    },

    onEnded() {
      this.isPlaying = false;
    },

    formatTime(sec) {
      if (!sec || !isFinite(sec)) return "00:00";
      const m = Math.floor(sec / 60);
      const s = Math.floor(sec % 60);
      return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>
.audio-player {
  background: #dcdcdc;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 14px;
}

.cd-play {
  height: 56px;
  border-radius: 50%;
  border: 4px solid #1e7df2;
  background: #f5f5f5;
  color: #1e7df2;
  font-size: 18px;
  line-height: 1;
  display: grid;
  place-items: center;
  cursor: pointer;
  width: 56px;
}

.cd-times {
  flex: 1;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 10px;
}

.cd-time {
  font-size: 12px;
  font-weight: 600;
  opacity: 0.9;
}

.cd-progress {
  width: 100%;
  appearance: none;
  height: 8px;
  border-radius: 999px;
  background: linear-gradient(
    to right,
    #1e7df2 0%,
    #1e7df2 var(--pct, 0%),
    #ffffff var(--pct, 0%),
    #ffffff 100%
  );
  outline: none;
}

.cd-progress::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #1e7df2;
  border: 3px solid #ffffff;
  cursor: pointer;
}

.cd-progress::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #1e7df2;
  border: 3px solid #ffffff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/AudioPlayer.vue